// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== TabMessagerie — EPIC-51 — Thread style TabQuestionsReponses ===== */

/* \`.msg-thread-container\` et \`.msg-section-header\` ont ete retires : l'onglet est passe sur
   SectionPliable, qui fournit l'entete et la zone de contenu. Le bouton « Imprimer la discussion »
   vit dans la barre d'actions du bas, pas dans l'entete — il n'a rien perdu au change. */

/* ── Bannière info ────────────────────────────────────────────────────────── */

.msg-info-banner {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  color: #9a3412;
  font-size: 1.1rem;
  margin: 0.5rem 0;
}

/* ── Thread zone ─────────────────────────────────────────────────────────── */

/* Le fil se raccorde a l'element qui le precede : pas de marge, pas de bordure ni d'arrondi en haut. */
.msg-thread {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 0.5rem 0.5rem;
  margin: 0 0 0.5rem;
  min-height: 300px;
  max-height: 500px;
}

.msg-empty {
  padding: 2rem;
  color: #9ca3af;
  font-size: 1.3rem;
  text-align: center;
  margin: auto;
}

.msg-loading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.5rem;
  color: #6b7280;
  font-size: 1.3rem;
  margin: auto;
}

.msg-error {
  font-size: 1.2rem;
  color: #ef4444;
}

/* ── Bubble ──────────────────────────────────────────────────────────────── */

.msg-bubble {
  max-width: 75%;
  padding: 0.6rem 1rem;
  border-radius: 0.75rem;
  position: relative;
  line-height: 1.45;
}

/* Message de l'autre parti (gauche) */
.msg-bubble--acheteur {
  align-self: flex-start;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-bottom-left-radius: 0.25rem;
}

.msg-bubble--prestataire {
  align-self: flex-start;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-bottom-left-radius: 0.25rem;
}

/* Mes propres messages (droite) */
.msg-bubble--mine {
  align-self: flex-end;
  background: #fff7ed;
  border-color: #fed7aa;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.75rem;
}

.msg-bubble-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
}

.msg-bubble-author {
  font-size: 1.1rem;
  font-weight: 600;
  color: #6b7280;
}

.msg-bubble--mine .msg-bubble-author {
  color: #f97316;
}

.msg-bubble-date {
  font-size: 1rem;
  color: #9ca3af;
  margin-left: auto;
}

.msg-bubble-body {
  font-size: 1.25rem;
  color: #374151;
  white-space: pre-wrap;
}

/* ── Input bar ───────────────────────────────────────────────────────────── */

.msg-input-bar {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem 0;
  border-top: 1px solid #e5e7eb;
}

.msg-input-textarea {
  width: 100%;
  min-height: 50px;
  padding: 0.6rem 1rem;
  font-size: 1.25rem;
  font-family: inherit;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  resize: none;
  box-sizing: border-box;
}

.msg-input-textarea:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);
}

.msg-input-textarea::placeholder {
  color: #9ca3af;
}

.msg-input-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
}

.msg-char-count {
  font-size: 1rem;
  color: #9ca3af;
}

.msg-send-error {
  font-size: 1rem;
  color: #ef4444;
}

/* Barre d'ACTIONS de l'onglet : hors de la section, en bas de page. Geometrie alignee sur les
   barres d'actions des autres onglets (\`.opms__actions\` : flex-end, gap 1rem, margin-top 1.5rem)
   pour que la messagerie ne fasse pas exception. */
.msg-actions-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

/* ── Section (SectionPliable) ─────────────────────────────────────────────────
   Le fil n'est plus colle a un entete : il vit dans la zone blanche de la section, comme les
   tableaux et blocs des autres onglets. Il reprend donc une bordure COMPLETE et un rayon sur les
   quatre coins (il portait \`border-top: none\` + rayon bas uniquement pour se souder a l'ancien
   entete maison). */
.msg-section .msg-thread {
  border-top: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  /* \`flex: 1\` etait resolu par \`.msg-thread-container\` (flex column, height 100%), supprime avec
     l'entete maison. Une hauteur maximale explicite conserve le defilement du fil. */
  max-height: 55vh;
}

/* La regle d'anonymat retrouve l'apparence normale d'une banniere : elle n'est plus coincee entre
   un entete gris et le fil, elle ouvre simplement le contenu de la section. */
`, "",{"version":3,"sources":["webpack://./src/composants/TabMessagerie/TabMessagerie.css"],"names":[],"mappings":"AAAA,4EAA4E;;AAE5E;;yFAEyF;;AAEzF,gFAAgF;;AAEhF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E,uGAAuG;AACvG;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;mDAEmD;AACnD;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;;oBAIoB;AACpB;EACE,6BAA6B;EAC7B,qBAAqB;EACrB;qFACmF;EACnF,gBAAgB;AAClB;;AAEA;8EAC8E","sourcesContent":["/* ===== TabMessagerie — EPIC-51 — Thread style TabQuestionsReponses ===== */\n\n/* `.msg-thread-container` et `.msg-section-header` ont ete retires : l'onglet est passe sur\n   SectionPliable, qui fournit l'entete et la zone de contenu. Le bouton « Imprimer la discussion »\n   vit dans la barre d'actions du bas, pas dans l'entete — il n'a rien perdu au change. */\n\n/* ── Bannière info ────────────────────────────────────────────────────────── */\n\n.msg-info-banner {\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 0.5rem;\n  padding: 0.75rem 1rem;\n  color: #9a3412;\n  font-size: 1.1rem;\n  margin: 0.5rem 0;\n}\n\n/* ── Thread zone ─────────────────────────────────────────────────────────── */\n\n/* Le fil se raccorde a l'element qui le precede : pas de marge, pas de bordure ni d'arrondi en haut. */\n.msg-thread {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-top: none;\n  border-radius: 0 0 0.5rem 0.5rem;\n  margin: 0 0 0.5rem;\n  min-height: 300px;\n  max-height: 500px;\n}\n\n.msg-empty {\n  padding: 2rem;\n  color: #9ca3af;\n  font-size: 1.3rem;\n  text-align: center;\n  margin: auto;\n}\n\n.msg-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1.5rem;\n  color: #6b7280;\n  font-size: 1.3rem;\n  margin: auto;\n}\n\n.msg-error {\n  font-size: 1.2rem;\n  color: #ef4444;\n}\n\n/* ── Bubble ──────────────────────────────────────────────────────────────── */\n\n.msg-bubble {\n  max-width: 75%;\n  padding: 0.6rem 1rem;\n  border-radius: 0.75rem;\n  position: relative;\n  line-height: 1.45;\n}\n\n/* Message de l'autre parti (gauche) */\n.msg-bubble--acheteur {\n  align-self: flex-start;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.msg-bubble--prestataire {\n  align-self: flex-start;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-bottom-left-radius: 0.25rem;\n}\n\n/* Mes propres messages (droite) */\n.msg-bubble--mine {\n  align-self: flex-end;\n  background: #fff7ed;\n  border-color: #fed7aa;\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.75rem;\n}\n\n.msg-bubble-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.25rem;\n}\n\n.msg-bubble-author {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.msg-bubble--mine .msg-bubble-author {\n  color: #f97316;\n}\n\n.msg-bubble-date {\n  font-size: 1rem;\n  color: #9ca3af;\n  margin-left: auto;\n}\n\n.msg-bubble-body {\n  font-size: 1.25rem;\n  color: #374151;\n  white-space: pre-wrap;\n}\n\n/* ── Input bar ───────────────────────────────────────────────────────────── */\n\n.msg-input-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0.75rem 0;\n  border-top: 1px solid #e5e7eb;\n}\n\n.msg-input-textarea {\n  width: 100%;\n  min-height: 50px;\n  padding: 0.6rem 1rem;\n  font-size: 1.25rem;\n  font-family: inherit;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  resize: none;\n  box-sizing: border-box;\n}\n\n.msg-input-textarea:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.15);\n}\n\n.msg-input-textarea::placeholder {\n  color: #9ca3af;\n}\n\n.msg-input-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n.msg-char-count {\n  font-size: 1rem;\n  color: #9ca3af;\n}\n\n.msg-send-error {\n  font-size: 1rem;\n  color: #ef4444;\n}\n\n/* Barre d'ACTIONS de l'onglet : hors de la section, en bas de page. Geometrie alignee sur les\n   barres d'actions des autres onglets (`.opms__actions` : flex-end, gap 1rem, margin-top 1.5rem)\n   pour que la messagerie ne fasse pas exception. */\n.msg-actions-bar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n/* ── Section (SectionPliable) ─────────────────────────────────────────────────\n   Le fil n'est plus colle a un entete : il vit dans la zone blanche de la section, comme les\n   tableaux et blocs des autres onglets. Il reprend donc une bordure COMPLETE et un rayon sur les\n   quatre coins (il portait `border-top: none` + rayon bas uniquement pour se souder a l'ancien\n   entete maison). */\n.msg-section .msg-thread {\n  border-top: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  /* `flex: 1` etait resolu par `.msg-thread-container` (flex column, height 100%), supprime avec\n     l'entete maison. Une hauteur maximale explicite conserve le defilement du fil. */\n  max-height: 55vh;\n}\n\n/* La regle d'anonymat retrouve l'apparence normale d'une banniere : elle n'est plus coincee entre\n   un entete gris et le fil, elle ouvre simplement le contenu de la section. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
